import React, { ReactNode } from 'react';
import { Icon, Icons } from '../Icon/Icon';
import styles from './Button.module.scss';
import cx from 'classnames';
import { Text } from 'components';

type Props = {
  onClick(): void;
  type?: 'primary' | 'secondary';
  isDisabled?: boolean;
  isLink?: boolean;
  leftIcon?: Icons;
  className?: string;
  children: ReactNode;
  isSmall?: boolean;
};

export const Button = ({
  type = 'primary',
  isDisabled = false,
  isLink = false,
  leftIcon,
  children,
  onClick,
  className = '',
  isSmall = false,
}: Props) => {
  return (
    <button
      onClick={onClick}
      className={cx(
        styles[type],
        { [styles.disabled]: isDisabled, [styles.link]: isLink, [styles.smallButton]: isSmall },
        className,
      )}>
      {leftIcon && <Icon name={leftIcon} />}
      <Text type="button">{children}</Text>
    </button>
  );
};
